<template>
  <div>
    <div v-for="(num,idx) in count" :key="'reveal-step-'+idx" class="reveal-step-form">
      <transition name="step-anim">
        <div v-if="openedSteps[idx]">
          <slot
            :name="'step'+idx"
            :openNextStep="openNextStep(idx)"
            :isNextStepClosed="isNextStepClosed(idx)"
          ></slot>
        </div>
      </transition>
    </div>
    <slot name="progress-indicator" :currentStep="this.openedSteps.length-1" :count="count" >
      <div class="mt-3 text-muted">Step {{this.openedSteps.length-1}} of {{count}}</div>
    </slot>
  </div>
</template>


<script>
import smoothScroll from "./smoothScroll";

export default {
  props: {
    count: {
      type: Number,
      default: 1
    },
    offsetY: {
      type: Number,
      default: 0
    },
    openUntilStep: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      openedSteps: []
    };
  },
  created() {
    // for (let index = 0; index <= this.openUntilStep; index++) {
    //   this.openedSteps.push(true);
    // }
  },
  watch: {
    openUntilStep: {
      immediate: true,
      handler: function(newValue, oldValue) {
        if (newValue != oldValue) {
          this.openedSteps = [];
          for (let index = 0; index <= newValue; index++) {
            this.openedSteps.push(true);
          }
        }
      }
    }
  },
  methods: {
    openNextStep(step) {
      return focus => {
        this.openStep(step + 1, focus);
      };
    },
    openStep(step, focus = true) {
      this.$set(this.openedSteps, step, true);

      if (focus) {
        this.$nextTick(() => {
          //Deslizando scroll para focar na etapa
          var stepsElm = this.$el.querySelectorAll(".reveal-step-form");
          var stepElm = stepsElm[step];
          smoothScroll.smoothScrollYToElement(stepElm, 700, this.offsetY);
        });
      }

      this.$emit("step-changed", this.openedSteps.length - 1);
    },
    isNextStepClosed(currentStep) {
      //Exibe o continuar se a próxima etapa estiver fechada
      var isClosed = !this.openedSteps[currentStep + 1];
      return isClosed;
    }
  }
};
</script>

<style scoped>
/* Animação das Etapas */
.step-anim-enter-active,
.step-anim-leave-active {
  transition: all 400ms ease-in;
}
.step-anim-enter,
.step-anim-leave-to {
  opacity: 0;
}
</style>